module.exports = __webpack_public_path__ + "media/images/riders/small/GERHARD_KERSCHBAUMER-8292764e8f3dc27c891064e9e6bd7585.png";